import { DeltaEventRecordingSettings } from '@core/models/structure/daq/signal.model';

export enum enumData {
  View = 'READ',
  Operate = 'OPERATE',
  Configuration = 'CONFIGURATION',
  AccessRightManagement = 'ACCESSRIGHTMANAGEMENT',
  Company = 'COMPANY',
  ContactPerson = 'CONTACTPERSON',
  SinglePerson = 'SINGLEPERSON',
  Manufacturer = 'MANUFACTURER',
  Vendor = 'VENDOR',
  Provider = 'PROVIDER',
  Customer = 'CUSTOMER',
  Location = 'LOCATION',
  Staff = 'STAFF',
  LiveFirst = 'LIVEFIRST',
  ArchiveFirst = 'ARCHIVEFIRST',
  ArchiveOnly = 'ARCHIVEONLY',
  ProcessInterval = 'PROCESSINTERVAL',
  Plan = 'PLAN',
  RasterRecordingSettings = 'RASTERRECORDINGSETTINGS',
  DeltaEventRecordingSettings = 'DELTAEVENTRECORDINGSETTINGS',
  SubInterval = 'SUBINTERVALCOMPRESSIONTYPE',
  HourInterval = 'HOURINTERVALCOMPRESSIONTYPE',
  TwoHourInterval = 'TWOHOURINTERVALCOMPRESSIONTYPE',
  DayInterval = 'DAYINTERVALCOMPRESSIONTYPE',
  WeekInterval = 'WEEKINTERVALCOMPRESSIONTYPE',
  MonthInterval = 'MONTHINTERVALCOMPRESSIONTYPE',
  QuarterInterval = 'QUARTERINTERVALCOMPRESSIONTYPE',
  YearInterval = 'YEARINTERVALCOMPRESSIONTYPE',
  DigitalInput = 'DIGITALINPUT',
  DigitalInOut = 'DIGITALINOUT',
  AnalogInput = 'ANALOGINPUT',
  AnalogInOut = 'ANALOGINOUT',
  Counter = 'COUNTER',
  UniversalInput = 'UNIVERSALINPUT',
  UniversalInOut = 'UNIVERSALINOUT',
  MeanValue = 'MEANVALUE',
  LastValue = 'LASTVALUE',
  None = 'NONE',
  LiveFlowMeter = 'LIVEFLOWMETER',
  WeightedMean = 'WEIGHTEDMEAN',
  ArithmeticMean = 'ARITHMETICMEAN',
  Difference = 'DIFFERENCE',
  Sum = 'SUM',
  Time = 'TIME',
  Text = 'TEXT',
  Mail = 'EMAIL',
  Email = 'EMAIL',
  ShortMessageService = 'SHORTMESSAGESERVICE',
  VoiceCall = 'VOICECALL',
  Signal = 'SIGNAL',
  Datasource = 'DATASOURCE',
  DataSource = 'DATASOURCE',
  Group = 'GROUP',
  User = 'USER',
  Dashboard = 'DASHBOARD',
  Processimage = 'PROCESSIMAGE',
  Reporttemplate = 'REPORTTEMPLATE',
  Report = 'REPORT',
  EventDefinition = 'EVENTDEFINITION',
  EventCondition = 'EVENTCONDITION',
  Camera = 'CAMERA',
  RecipientGroup = 'RECIPIENTGROUP',
  Recipient = 'RECIPIENT',
  AlarmingPlan = 'ALARMINGPLAN',
  Role = 'ROLE',
  MaintenanceObject = 'MAINTENANCEOBJECT',
  MaintenanceObjectCategory = 'MAINTENANCEOBJECTCATEGORY',
  MaintenanceProperty = 'MAINTENANCEPROPERTY',
  Contact = 'CONTACT',
  This = 'THIS',
  All = 'ALL',
  Default = 'DEFAULT',
  MaintenanceTemplates = 'MAINTENANCETEMPLATE',
  HourValues = 'HOURVALUES',
  DayValues = 'DAYVALUES',
  WeekValues = 'WEEKVALUES',
  MonthValues = 'MONTHVALUES',
  YearValues = 'YEARVALUES',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
  Day = 'DAY',
  Monitoring = 'MONITORING',
  Visualisation = 'VISUALISATION',
  Live = 'LIVE',
  Reporting = 'REPORTING',
  Analysis = 'ANALYSIS',
  Chart = 'CHART',
  weekly = 'WEEKLY',
  monthly = 'MONTHLY',
  yearly = 'YEARLY',
  simple = 'SIMPLE',
  Open = 'OPEN',
  InProcessing = 'IN_PROCESSING',
  Assigned = 'ASSIGNED',
  Done = 'DONE',
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Thursday = 'THURSDAY',
  Wednesday = 'WEDNESDAY',
  Saturday = 'SATURDAY',
  Friday = 'FRIDAY',
  Closed = 'CLOSED',
  'Ticket.Open' = 'TICKETOPEN',
  MaintenanceTask = 'TASK',
  free = 'FREE',
  ticket = 'TICKET',
  vacation = 'VACATION',
  illness = 'ILLNESS',
  schooling = 'SCHOOLING',
  meeting = 'MEETING',
  birthday = 'BIRTHDAY',
  appointment = 'APPOINTMENT',
  Pending = 'PENDING',
  Failed = 'FAILED',
  Denied = 'DENIED',
  Successful = 'SUCCCESSFUL',
  Contacts = 'CONTACTS',
  Recipients = 'RECIPIENT',
  Logging = 'LOGGING',
  Planing = 'PLANING',
  LineSeriesOptions = 'LINESERIESOPTIONS',
  StepLineSeriesOptions = 'STEPLINESERIESOPTIONS',
  ColumnSeriesOptions = 'COLUMNSERIESOPTIONS',
  Description = 'DESCRIPTION',
  Type = 'TYPE',
  Name = 'NAME',
  FirstName = 'FIRSTNAME',
  LastName = 'LASTNAME',
  Id = 'ID',
  DigitalSwitch = 'DIGITALSWITCH',
  Image = 'IMAGE',
  Notes = 'NOTES',
  LiquidFillGauge = 'LIQUIDFILLGAUGE',
  TicketList = 'TICKETLIST',
  FileBrowser = 'FILEBROWSER',
  MaintenanceAnalysis = 'MAINTENANCEANALYSIS',
  SignalAnalysis = 'SIGNALANALYSIS',
  ObjectAnalysis = 'OBJECTANALYSIS',
  EventLog = 'EVENTLOG',
  AlarmingLog = 'ALARMINGLOG',
  GroupId = 'GROUPID',
  Address = 'ADDRESS',
  DataConnectionId = 'DATACONNECTIONID',
  Path = 'PATH',
  Tenant = 'TENANT',
  UserProfilePool = 'USERPROFILEPOOL',
  MaintenanceDocument = 'MAINTENANCEDOCUMENTS',
  MaintenanceDocuments = 'MAINTENANCEDOCUMENTS',
  MaintenancePool = 'MAINTENANCEPOOL',
  MaintenanceDocumentPool = 'MAINTENANCEDOCUMENTPOOL',
  IsDefaultRole = 'ISDEFAULTROLE',
  Equation = 'EQUATION'
}
